import { TransientLayerState } from '../../../../../core/outputs/annotation/annotation-shared/state/layers/transient-layer-state';

export class TransientRasterLayerState extends TransientLayerState {
  constructor() {
    super();
  }
}
